// import React, { useState } from "react";

// const Terms = ({onNext}) => {
//   const [isChecked, setIsChecked] = useState(false);

//   const handleCheckboxChange = (e) => {
//     setIsChecked(e.target.checked);
//   };
//   const handleProceed = () => {
//     // ... any logic for this step ...
//     if (typeof onNext === 'function') {
//       onNext(); // Call the function passed from Company.js
//     } else {
//       console.error("Registration: onNext prop is not a function!");
//     }
//   };

//   return (
//     <div
//       className="text-center container"
//       style={{
//         boxShadow: "0 0 15px 5px rgba(0, 0, 0, 0.08)",
//         width: "815px",
//         height: "482px",
//         borderRadius: "10px",
//         padding: "20px",
//       }}
//     >
//       <h3 style={{ fontWeight: "bold" }} className="mb-4">
//         Terms and Conditions
//       </h3>

//       <ol className="text-start mx-auto" style={{ maxWidth: "700px" }}>
//         <li>
//           <strong>Reservation Policy</strong>
//           <ul>
//             <li>Customers are encouraged to make reservations in advance.</li>
//             <li>
//               Reservations are held for 15 minutes beyond the scheduled time.
//             </li>
//           </ul>
//         </li>
//         <li>
//           <strong>Cancellation Policy</strong>
//           <ul>
//             <li>
//               Please cancel or modify your reservation at least 2 hours before
//               your scheduled time.
//             </li>
//             <li>Late cancellations may incur a fee.</li>
//           </ul>
//         </li>
//         <li>
//           <strong>Payment Terms</strong>
//           <ul>
//             <li>
//               We accept cash, major credit/debit cards, and online payments.
//             </li>
//             <li>
//               All prices are inclusive of applicable taxes unless mentioned
//               otherwise.
//             </li>
//           </ul>
//         </li>
//       </ol>

//       <label className="my-3 d-block">
//         <input
//           style={{ transform: "scale(1.2)", marginRight: "8px" }}
//           type="checkbox"
//           name="terms"
//           onChange={handleCheckboxChange}
//         />
//         I agree to the Terms and Conditions
//       </label>

//       {isChecked && (
//         <div className="d-flex justify-content-center gap-4 mt-3">
//           {/* <button style={{ fontWeight: "bold" }} type="button" className="btn btn-primary">
//             Save
//           </button> */}
//           <button style={{ fontWeight: "bold" }} type="button" className="btn btn-success"  onClick={handleProceed}>
//             Next
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Terms;




import React, { useState } from "react";

const Terms = ({ onNext }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleProceed = () => {
    if (typeof onNext === "function") {
      onNext();
    } else {
      console.error("Registration: onNext prop is not a function!");
    }
  };

  return (
    <div className="terms-container">
      <h3 className="terms-heading">Terms and Conditions</h3>

      <ol className="terms-list">
        <li>
          <strong>Reservation Policy</strong>
          <ul>
            <li>Customers are encouraged to make reservations in advance.</li>
            <li>Reservations are held for 15 minutes beyond the scheduled time.</li>
          </ul>
        </li>
        <li>
          <strong>Cancellation Policy</strong>
          <ul>
            <li>
              Please cancel or modify your reservation at least 2 hours before
              your scheduled time.
            </li>
            <li>Late cancellations may incur a fee.</li>
          </ul>
        </li>
        <li>
          <strong>Payment Terms</strong>
          <ul>
            <li>We accept cash, major credit/debit cards, and online payments.</li>
            <li>All prices are inclusive of applicable taxes unless mentioned otherwise.</li>
          </ul>
        </li>
      </ol>

      <label className="terms-checkbox">
        <input
          type="checkbox"
          name="terms"
          onChange={handleCheckboxChange}
        />
        I agree to the Terms and Conditions
      </label>

      {isChecked && (
        <div className="terms-actions">
          <button type="button" className="btn-next" onClick={handleProceed}>
            Next
          </button>
        </div>
      )}

      {/* Internal CSS */}
      <style>{`
        .terms-container {
          max-width: 930px;
          width: 100%;
          margin: 20px auto;
          padding: 20px;
          border-radius: 10px;
          box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.08);
          background-color: #fff;
          text-align: center;
        }

        .terms-heading {
          font-weight: bold;
          margin-bottom: 20px;
        }

        .terms-list {
          text-align: left;
          margin: 0 auto;
          max-width: 700px;
          padding-left: 20px;
        }

        .terms-checkbox {
          display: block;
          margin: 20px 0;
          font-size: 1rem;
        }

        .terms-checkbox input {
          transform: scale(1.2);
          margin-right: 10px;
        }

        .terms-actions {
          display: flex;
          justify-content: center;
          margin-top: 20px;
        }

        .btn-next {
          background-color: #28a745;
          color: white;
          border: none;
          padding: 10px 20px;
          font-weight: bold;
          border-radius: 5px;
          cursor: pointer;
          font-size: 1rem;
        }

        .btn-next:hover {
          background-color: #218838;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .terms-container {
            padding: 15px;
          }

          .terms-list {
            padding-left: 15px;
            font-size: 0.95rem;
          }

          .terms-checkbox {
            font-size: 0.95rem;
          }

          .btn-next {
            width: 100%;
            padding: 12px;
          }
        }

        @media (max-width: 480px) {
          .terms-container {
            padding: 10px;
          }

          .terms-heading {
            font-size: 1.25rem;
          }

          .terms-list {
            font-size: 0.9rem;
          }

          .btn-next {
            font-size: 0.95rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Terms;

